import {
  availableStartTimes,
  allAvailableStartTimes,
} from '@/logic/helpers/bookingSlots/getMeetingSlots';

const getHoursInRange = (
  startHour: string,
  endHour: string,
  includeAllStartingHours?: boolean,
): string[] => {
  const times = includeAllStartingHours ? allAvailableStartTimes : availableStartTimes;
  const availableHours: string[] = times.map((hour) =>
    hour.split(':')[0].length === 1 ? `0${hour}` : hour,
  );
  const sliceStart: number = availableHours.indexOf(startHour);
  const sliceEnd: number = availableHours.indexOf(endHour);

  return availableHours.slice(sliceStart, sliceEnd);
};

export default getHoursInRange;
